import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import Header from "components/Header";
import TabSwitch from "components/TabSwitch";
import { BROKER_MY_CARRIER_TAB_ITEMS } from "constants/haulpay-broker";
import { routes } from "constants/routes";
import MainLayout from "layouts/Main";
import { selectUserDetails } from "store/user/selector";
import { BrokerProvider } from "context/BrokerContext";

export default function BrokerMyCarriers() {
  const userDetails = useSelector(selectUserDetails);

  return (
    <BrokerProvider>
      <MainLayout
        desktopTitle="My Carriers"
        customHeader={<Header label="My Carriers" goBackPath={routes.HAULPAY} isHideDesktop />}
        className="gap-5 px-5">
        <TabSwitch options={BROKER_MY_CARRIER_TAB_ITEMS} />

        {userDetails && <Outlet />}
      </MainLayout>
    </BrokerProvider>
  );
}
